module.exports = __webpack_public_path__ + "img/similar-demo.6ebc37e.gif";